class productMedia extends HTMLElement {
  constructor() {
    super();
    const thumbnails = this.querySelectorAll('.media-thumb');
    const slider = this.querySelector('.product-media');
    const container = this.closest('[data-product]');
    const section = this.closest('[data-section-type="product-template"]');

    slider.addEventListener('sliderMade', () => {
      const flkty = Flickity.data(slider);
      thumbnails.forEach((thumb) => {
        thumb.addEventListener('click', function () {
          const selectedSlide = thumb.dataset.index;
          flkty.select(selectedSlide - 1);
        });
      });
    });

    section.addEventListener('theme:variant:change', (event) => {
      const variantData = JSON.parse(
        container.querySelector('[data-product-json]').textContent
      );
      const newVariantId = container.querySelector('[name="id"]').value;

      const selectedVariant = Object.values(variantData.variants).find(
        (obj) => obj.id == newVariantId
      );

      if (selectedVariant && selectedVariant.featured_media) {
        const imageIndex = selectedVariant.featured_media.position;
        const flkty = Flickity.data(slider);
        if (flkty) flkty.select(imageIndex - 1);
      }
    });
  }
}
customElements.define('product-media', productMedia);

const swatchDropdown = () => {
  if (!document.querySelector('[data-swatch-dropdown]')) return;

  fetch(window.bdSwatchesUrl + '?v=' + Date.now())
    .then(res => res.json())
    .then(data => {
      const swatches = {};
      data.colors.forEach(item => {
        const key = Object.keys(item)[0];
        swatches[key] = item[key];
      });

      document.querySelectorAll('[data-swatch-color-option]').forEach(dot => {
        const key = dot.getAttribute('data-swatch-color-option');
        const hex = swatches[key] || '#C8C8C8';
        dot.style.background = hex;
      });

      const swatchPopout = document.querySelector('[data-swatch-dropdown]');
      if (!swatchPopout) return;

      const toggle = swatchPopout.querySelector('[data-popout-toggle]');
      const list = swatchPopout.querySelector('[data-popout-list]');
      const popoutText = toggle.querySelector('[data-popout-text]');

      toggle.addEventListener('click', () => {
        const isOpen = list.classList.contains('select-popout__list--visible');
        list.classList.toggle('select-popout__list--visible', !isOpen);
        toggle.setAttribute('aria-expanded', !isOpen);
      });

      swatchPopout.querySelectorAll('[data-popout-option]').forEach(option => {
        option.addEventListener('click', function(e) {
          e.preventDefault();

          const value = this.getAttribute('data-value');
          const key = value.toLowerCase();
          const hex = swatches[key] || '#C8C8C8';

          popoutText.textContent = value;

          const swatchDot = swatchPopout.querySelector('[data-swatch-color]');
          if (swatchDot) swatchDot.style.background = hex;

          swatchPopout.querySelectorAll('[data-popout-option]').forEach(opt => {
            opt.closest('li').classList.remove('select-popout__item--current');
            opt.removeAttribute('aria-current');
          });
          this.closest('li').classList.add('select-popout__item--current');
          this.setAttribute('aria-current', 'true');

          list.classList.remove('select-popout__list--visible');
          toggle.setAttribute('aria-expanded', 'false');

          const radio = document.querySelector(
            '[data-single-option-selector][value="' + value + '"]:not([data-popout-input])'
          );
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });

      const initialValue = popoutText.textContent.trim();
      const initialHex = swatches[initialValue.toLowerCase()] || '#C8C8C8';
      const initialDot = swatchPopout.querySelector('[data-swatch-color]');
      if (initialDot) initialDot.style.background = initialHex;
    })
    .catch(err => console.error('bd-pdp: failed to load swatches.json', err));
};

document.addEventListener('click', e => {
  const swatchPopout = document.querySelector('[data-swatch-dropdown]');
  if (swatchPopout && !swatchPopout.contains(e.target)) {
    swatchPopout.querySelector('[data-popout-list]')?.classList.remove('select-popout__list--visible');
    swatchPopout.querySelector('[data-popout-toggle]')?.setAttribute('aria-expanded', 'false');
  }
});

document.addEventListener('DOMContentLoaded', swatchDropdown);
document.addEventListener('shopify:section:load', swatchDropdown);